import React, {useState} from "react";
import {useForm} from 'react-hook-form'
import {NavLink} from "react-router-dom";
import {
    Box,
    Button,
    Flex,
    FormControl, FormErrorMessage,
    FormLabel,
    Heading,
    Icon,
    Input,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/auth/landingpage-background.jpg";
import {postData} from "../../../services/api";
import Footer from "../../../components/footer/FooterAuth";
import {FaChevronLeft} from "react-icons/fa";

function ForgotPassword() {
    // Chakra color mode
    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";
    const brandStars = useColorModeValue("brand.500", "brand.400");
    const [success, setSuccess] = useState(false);

    const {
        handleSubmit,
        register,
        formState: {errors, isSubmitting},
    } = useForm()

    function onSubmit(values) {
        return new Promise(async (resolve) => {
            try {
                await postData('/api/forgot-password', values);
                setSuccess(true)
                resolve();
            } catch (error) {
                console.error('Fehler:', error);
            }
        })
    }

    return (
        <Box>
            <DefaultAuth illustrationBackground={illustration} image={illustration}>
                <Flex
                    maxW={{base: "100%", md: "500px"}}
                    w={{base: "100%", md: "40vw"}}
                    mx={{base: "auto", lg: "0px"}}
                    me='auto'
                    h='100%'
                    alignItems='start'
                    justifyContent='center'
                    mb={{base: "30px", md: "60px"}}
                    px={{base: "25px", md: "0px"}}
                    mt={{base: "40px", md: "14vh"}}
                    flexDirection='column'>
                    <Box me='auto'>
                        <Heading color={textColor} fontSize='36px' mb='10px'>
                            Passwort zurücksetzen
                        </Heading>
                        <Text
                            mb='36px'
                            ms='4px'
                            color={textColorSecondary}
                            fontWeight='400'
                            fontSize='md'
                        >
                            Du hast dein Passwort vergessen? Kein Problem, gib hier deine Email-Adresse an und wir
                            senden dir einen Link zum Zurücksetzen deines Passwortes. Bitte schau auch in deinen
                            Spam-Ordner falls unsere Nachricht dort gelandet ist.
                        </Text>
                    </Box>
                    {success ? (
                        <Text
                            fontWeight='400'
                            fontSize='md'
                            w={{base: "100%", md: "420px"}}
                        >
                            Wir haben dir einen Link zum Zurücksetzen des Passwortes zugesendet.
                        </Text>
                    ) : (
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Flex
                                zIndex='2'
                                direction='column'
                                w={{base: "100%", md: "420px"}}
                                maxW='100%'
                                borderRadius='15px'
                                mx={{base: "auto", lg: "unset"}}
                                me='auto'
                                mb={{base: "20px", md: "auto"}}>
                                <FormControl isInvalid={!!errors.email}>
                                    <FormLabel
                                        display='flex'
                                        ms='4px'
                                        fontSize='md'
                                        fontWeight='500'
                                        color={textColor}
                                        htmlFor='email'
                                    >
                                        Email<Text color={brandStars}>*</Text>
                                    </FormLabel>
                                    <Input
                                        id='email'
                                        fontSize='md'
                                        ms={{base: "0px", md: "0px"}}
                                        type='text'
                                        fontWeight='500'
                                        size='md'
                                        {...register('email', {
                                            required: 'Gib hier deine Email-Adresse an',
                                        })}
                                    />
                                    <FormErrorMessage>
                                        {errors.email && errors.email.message}
                                    </FormErrorMessage>
                                </FormControl>

                                <Flex gap={5}>
                                    <Button
                                        fontSize='md'
                                        variant='outline'
                                        fontWeight='500'
                                        w='33%'
                                        h='50'
                                        mt='5'
                                        mb='5'
                                    >
                                        <NavLink to='/auth/login'>Zum Login</NavLink>
                                    </Button>
                                    <Button
                                        fontSize='md'
                                        variant='brand'
                                        fontWeight='500'
                                        w='100%'
                                        h='50'
                                        mt='5'
                                        mb='5'
                                        isLoading={isSubmitting}
                                        type='submit'
                                    >
                                        Passwort zurücksetzen
                                    </Button>
                                </Flex>
                            </Flex>
                        </form>
                    )}
                </Flex>
            </DefaultAuth>

            <Footer/>
        </Box>
    );
}

export default ForgotPassword;
